import { SuccessIcon, SummaryRow, MerchantButton } from "@components";
import { formatAmount } from "@utils";
import { useEffect } from "react";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import { getCardPayment, getOpenBankingPayment } from "@api";

const OplSuccess = () => {
  const { payment, merchant, setPayment } = useOutletContext();
  const navigate = useNavigate()

  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("p-id");
  const type = searchParams.get("t");


  useEffect(() => {

    const loadData = async () => {
      if (!payment) {
        if (!paymentId || !type) {
          navigate(`/payto/${merchant.organisationId}`);
        }
        else {
          let paymentData = null;
          if (type === "card") {
            paymentData = await getCardPayment(paymentId);
          }
          if (type === "openbanking") {
            paymentData = await getOpenBankingPayment(paymentId);
          }

          setPayment(paymentData);
        }
      }
    }

    loadData();
  }, []);


  return (payment && <div className="bg-zinc-100 h-dvh grow lg:h-full">
    <div className="w-full  lg:w-[480px] mx-auto flex flex-col items-center">
      <div className="size-[160px] mx-auto flex items-center justify-center mt-10">
        <SuccessIcon merchant={merchant} />
      </div>
      <h1 className="font-semibold text-xl mb-2">Payment successful</h1>
      <p className="text-zinc-500 text-center mb-5">We’ve successfully processed your payment</p>
      <div className="w-full px-8 py-5">
        <div className="bg-white rounded-xl border border-zinc-300 w-full">
          <SummaryRow pad label="Amount" value={formatAmount(payment.amount)} />
          <SummaryRow pad label="Recipient" value={merchant.name} />
          <SummaryRow pad label="Reference" value={payment.reference} />
        </div>
      </div>
      {merchant.paymentCompleteRedirectUrl &&
        <MerchantButton
        className="mt-5"
        width="[320px]"
        rounded="full"
        onClick={() => window.location.href = merchant.paymentCompleteRedirectUrl}
        merchant={merchant}>
        Done
      </MerchantButton>}
    </div>
  </div>);
};

export default OplSuccess;
